// extracted by mini-css-extract-plugin
export default {"container":"UiEmailInput_container_H4zxo","input":"UiEmailInput_input_g5T_J","domain":"UiEmailInput_domain_Uhp2r"};